import {
  NOW_EVENT_TAG,
  NEXT_EVENT_TAG,
  NOW_EVENT_TAG_COLOR,
  FOR_LATE_EVENT_TAG,
  PREVIOUS_EVENT_TAG,
  EVENT_ALREADY_STREAMED_TAG,
  PREVIOUS_EVENT_TAG_COLOR,
  NEXT_EVENT_TAG_COLOR
} from './Helpers/Constans';
import { Dates } from '../../packages/dates';
import { dateIsToday, calculateProgress } from './Helpers/Utils';
import EpgPersistence from '../../AAF/Nepg/EpgPersistence';
import { NpvrUtil } from '../../AAF/Npvr/NpvrUtil';
import channelStreamUtil from '../../utils/ChannelStreamUtil';
import { Pin } from '../../AAF/Pin/main';
import ReminderNotifications from '../../utils/RemindersNotifications/ReminderNotifications';
import LoadFav from '../../AAF/LoaderExp/LoadFav';
import { ThirdPartyEpgHelper } from '../../AAFPlayer/helpers/ThirdPartyEpgHelper';

class MiniDomManager {
  constructor() {

    this._callbacks = {};
    this._container = null;
    this._miniContainer = null;
    this._timerId = null;
    this._controlsVisibility = false;
    this._miniVisibility = false;
  }

  init(containerId, miniContainer, callbacks = {}) {
    this._callbacks = callbacks;
    this._container = document.getElementById(containerId);
    this._miniContainer = document.getElementById(miniContainer);
  }

  setVisibility(type, visibility) {
    if(type === 'mini') {
      this._miniVisibility = visibility;
    }
  }

  getVisibility(type) {
    switch (type) {
      case 'mini':
        return this._miniVisibility;
      case 'controls':
        return this._controlsVisibility;
    }
    return this._miniVisibility;
  }

  clearFocusableClassName= (type)=>{
    const el = document.getElementById(`mini-${type}-event`);
    if(el){
      el.classList.remove('focusable');
    }
  }

  addFocusableClassName= (type)=>{
    const el = document.getElementById(`mini-${type}-event`);
    if(el){
      el.classList.add('focusable');
    }
  }

  showMini() {
    this.setVisibility('mini', true);
    this.addFocusableClassName('principal');
    this.addFocusableClassName('secondary');
    this._miniContainer.style.visibility = 'visible';
    this._miniContainer.style.opacity = 100;
    if (this._callbacks.show && typeof this._callbacks.show === 'function') {
      this._callbacks.show();
    }
  }

  hideMini() {
    if (!this.getVisibility('mini')) {
      return;
    }
    this.setVisibility('mini', false);
    this.clearFocusableClassName('principal');
    this.clearFocusableClassName('secondary');
    this._miniContainer.style.visibility = 'hidden';
    this._miniContainer.style.opacity = 0;
    if (this._callbacks.hide && typeof this._callbacks.hide === 'function') {
      this._callbacks.hide();
    }
  }

  renderControls(channel, event) {
    if (channel && channel.cover) {
      document.getElementById('mini-current-channel-image').src = channel.cover; //"url('" + `${channel.cover}` + "')" ;
    } else {
      document.getElementById('mini-channel-image-container').src = 'none';
    }
    if (channel && channel.id) {
      document.getElementById('mini-current-channel-number').innerText = channel.id;
    }
    if (event && event.name) {
      document.getElementById('mini-header-event').innerText = event.name;
    }
  }

  renderChannel(channel = {}) {
    const favIcon = document.getElementById("mini-channel-fav-icon");
    if(favIcon){
      if(channel.group_id && LoadFav.isFavorite(channel.group_id)){
        favIcon.style.display = "block"
      }
      else{
        favIcon.style.display = "none"
      }
    }
    const blockIcon = document.getElementById("mini-channel-block-icon");
    if(channel.group_id && Pin.isBlockedChannelById(channel.group_id)){
      blockIcon.style.display = "block"
      document.getElementById('mini-channel-number-label').style.opacity = 0.5;
      document.getElementById('mini-channel-image-container').style.opacity = 0.5;
    }
    else{
      blockIcon.style.display = "none"
      document.getElementById('mini-channel-number-label').style.opacity = 1.0;
      document.getElementById('mini-channel-image-container').style.opacity = 1.0;
    }
    if (channel && channel.imageEpg) {
      document.getElementById('mini-channel-image-container').style.display = 'inline-block';
      document.getElementById('mini-channel-image').src = `${channel.imageEpg}`;
    } else {
      document.getElementById('mini-channel-image-container').style.display = 'none';
    }
    if (channel && channel.id) {
      document.getElementById('mini-channel-number-label').innerText = channel.id;
    }
  }

  renderEvents(event, channel = {}) {
    this.setEventTitle('principal', event);
    this.setEventTitle('secondary', event && event.nextEvent);
    this.setEventSchedule('principal', event);
    this.setEventSchedule('secondary', event && event.nextEvent);
    this.setEventScheduleTag('principal', event);
    this.setEventScheduleTag('secondary', event && event.nextEvent);
    this.setEventImage('principal', event, channel);
    this.setEventImage('secondary', event && event.nextEvent, channel);
    if (NpvrUtil.recordingIconEnable().enable) {
      this.checkRecordEvent('principal', event);
      this.checkRecordEvent('secondary', event && event.nextEvent);
    }
    this.checkReminderEvent('principal', event);
    this.checkReminderEvent('secondary', event && event.nextEvent);

  }

  checkReminderEvent(type = 'principal', event){
    const el = document.getElementById(`mini-${type}-event-reminder-icon`);
    if(el && el.style && el.style.display && event && event.tag !== NOW_EVENT_TAG && ReminderNotifications.hasEventReminder(event.id)){
      el.style.display = 'inline-block';
    }
    else{
      el.style.display = 'none';
    }
  }

  setEventScheduleTag(eventType, event) {
    const eventScheduleTag = document.getElementById(`mini-${eventType}-event-tag`);
    const eventScheduleTagContainer = document.getElementById(
      `mini-${eventType}-event-tag-container`
    );
    if (!eventScheduleTag || !eventScheduleTagContainer || !event) return;
    if (eventType === 'principal') {
      if (event.tag) {
        eventScheduleTag.innerText = event.tag;
        eventScheduleTagContainer.style.display = 'inline-block';
        if (event.tag === NOW_EVENT_TAG) {
          eventScheduleTagContainer.style.backgroundColor = NOW_EVENT_TAG_COLOR;
        } else if (event.tag === NEXT_EVENT_TAG || event.tag === FOR_LATE_EVENT_TAG) {
          eventScheduleTagContainer.style.backgroundColor = NEXT_EVENT_TAG_COLOR;
        } else if (
          event.tag === PREVIOUS_EVENT_TAG ||
          event.tag === EVENT_ALREADY_STREAMED_TAG
        ) {
          eventScheduleTagContainer.style.backgroundColor = PREVIOUS_EVENT_TAG_COLOR;
        }
      } else {
        eventScheduleTagContainer.style.display = 'inline-block';
        eventScheduleTag.innerText = NOW_EVENT_TAG;
        eventScheduleTagContainer.style.backgroundColor = NOW_EVENT_TAG_COLOR;
      }
    }
    if (eventType === 'secondary') {
      if (event.tag) {
        eventScheduleTag.innerText = event.tag;
        eventScheduleTagContainer.style.display = 'inline-block';
        if (event.tag === NOW_EVENT_TAG) {
          eventScheduleTagContainer.style.backgroundColor = NOW_EVENT_TAG_COLOR;
        } else if (event.tag === NEXT_EVENT_TAG || event.tag === FOR_LATE_EVENT_TAG) {
          eventScheduleTagContainer.style.backgroundColor = NEXT_EVENT_TAG_COLOR;
        } else if (
          event.tag === PREVIOUS_EVENT_TAG ||
          event.tag === EVENT_ALREADY_STREAMED_TAG
        ) {
          eventScheduleTagContainer.style.backgroundColor = PREVIOUS_EVENT_TAG_COLOR;
        }
      } else {
        eventScheduleTagContainer.style.display = 'inline-block';
        eventScheduleTag.innerText = NEXT_EVENT_TAG;
        eventScheduleTagContainer.style.backgroundColor = NEXT_EVENT_TAG_COLOR;
      }
    }
  }

  setEventSchedule(eventType, event) {
    const eventSchedule = document.getElementById(`mini-${eventType}-event-schedule`);
    if (!event || !eventSchedule) return;
    eventSchedule.innerText =
      event.date_begin && event.date_end && !ThirdPartyEpgHelper.isThirdPartyApp(event.group_id)
        ? `${
          dateIsToday(event.date_begin)
            ? ''
            : `${
              EpgPersistence.needsOffset()
                ? new Dates()
                  .unix(event.date_begin)
                  .utcOffset(EpgPersistence.needsOffset(), false)
                  .format('DD/MM')
                : new Dates().unix(event.date_begin).format('DD/MM')
              }   `
          }${
          EpgPersistence.needsOffset()
            ? new Dates()
              .unix(event.date_begin)
              .utcOffset(EpgPersistence.needsOffset(), false)
              .format('HH:mm')
            : new Dates().unix(event.date_begin).format('HH:mm')
          } - ${
          EpgPersistence.needsOffset()
            ? new Dates()
              .unix(event.date_end)
              .utcOffset(EpgPersistence.needsOffset(), false)
              .format('HH:mm')
            : new Dates().unix(event.date_end).format('HH:mm')
          }`
        : '';
  }

  setEventImage(eventType, event, channel = {}) {
    const eventImageContainer = document.getElementById(
      `mini-${eventType}-event-image-container`
    );
    const eventImage = document.getElementById(`mini-${eventType}-event-image`);
    const eventInfoContainer = document.getElementById(`mini-${eventType}-event-info-container`);
    if (!eventImageContainer || !eventImage || !event) return;

    const onError = (e)=> {
      if (channel && channel.imageEpg) {
        eventImageContainer.style.display = 'inline-block';
        eventImage.src = `${channel.imageEpg}`;
        eventInfoContainer.style.width = '66%';
      }
      else{
        eventInfoContainer.style.width = '100%';
        eventImageContainer.style.display = 'none';
      }
    }

    if (event.ext_eventimage_name) {
      eventImageContainer.style.display = 'inline-block';
      eventImage.src = `${event.ext_eventimage_name}`;
      eventImage.onerror = onError
      eventInfoContainer.style.width = '66%';
    } else {
      onError();
      eventImage.onerror = onError
    }
  }

  setEventTitle(eventType, event) {
    const eventTitle = document.getElementById(`mini-${eventType}-event-title`);
    if (!eventTitle || !event) return;
    eventTitle.innerText = event.name ? event.name!=='NA' ? event.name : EpgPersistence.getLabelNotAvailable() : EpgPersistence.getLabelNotAvailable() ;
  }

  checkRecordEvent(eventType = '', event) {
    if(!event){
      return;
    }
    this.setRecordImageInEvent(eventType, event.recording_status, event.group_id);
  }

  //* Funcion para pintar el icono de Grabar
  setRecordImageInEvent(eventType = 'principal', status = 0, groupId) {
    const image = document.getElementById(`mini-${eventType}-event-record-image`);
    const label = document.getElementById(`mini-${eventType}-event-record-label`);
    const asset =  NpvrUtil.getRecordingAsset(status);
    const {
      label: labelText = '',
      imageSrc = ''
    } =  asset;

    if (imageSrc !== '' && labelText !== '' && channelStreamUtil.get(groupId).npvr) {
      image.src = imageSrc;
      image.style.display = 'inline-block';
      label.style.display = 'inline-block';
      label.innerText = labelText;
    } else {
      label.innerText = '';
      image.style.display = 'none';
      label.style.display = 'none';
    }
  }

  renderEventProgress(date_begin, date_end, type = 'principal') {
    const progress = calculateProgress(date_begin, date_end);
    const progressDiv = document.getElementById(`mini-${type}-event-progress-container`);
    if (progressDiv) {
      progressDiv.style.display = 'inline-block';
      const lineDiv = document.getElementById(`mini-${type}-event-progress-line`);
      lineDiv.style.width = `${progress}%`;
    }
  }

  hideEventProgress(type = 'principal' ) {
    const progressDiv = document.getElementById(`mini-${type}-event-progress-container`);
    if (progressDiv) {
      progressDiv.style.display = 'none';
      const lineDiv = document.getElementById(`mini-${type}-event-progress-line`);
      lineDiv.style.width = `${0}%`;
    }
  }
}

export default MiniDomManager;



// WEBPACK FOOTER //
// ./src/components/PersistentMiniEpg/MiniDomManager.js